
import axios from '@/utils/axiosHelper';

// 初始化数据(含授权)
export const onGetInitDataAPI = (params) => {
  return axios({ url: '/lantern/activity/cake/init', method: 'GET', params }, { interceptResultCode: false });
};

// 开始游戏
export const getPlayKey = (data) => {
  return axios({ url: '/lantern/activity/cake/consume', method: 'POST', data });
};

// 提交游戏
export const submitGameData = (data) => {
  return axios({ url: '/lantern/activity/cake/lottery', method: 'POST', data });
};

// 分享
export const changeShareStatus = () => {
  return axios({ url: '/lantern/activity/cake/share', method: 'POST' });
};

// 新手指导更新
export const changeGuideStatus = () => {
  return axios({ url: '/lantern/activity/cake/status', method: 'POST' });
};

// 助力
export const onHelpAPI = (data) => {
  return axios({ url: '/lantern/activity/cake/help', method: 'POST', data }, { interceptResultCode: false });
};



// WEBPACK FOOTER //
// ./src/pages/tideng/journey/api.js